import {SmartComponent} from "smart-component-js";
import $ from 'jquery';
import GigyaManager from "../business/GigyaManager";
import CryptoJS from "crypto-js";
import Constants from "../business/Constants";
import PromoApi from "mbpromo/src/api/PromoApi";
import HttpClient from "../business/HttpClient";

class ScacchieriComponent extends SmartComponent {
    constructor(element, parentCtrl) {
        super(element, parentCtrl);

        this.$element = $(element);
        this.promoApi = new PromoApi({promoCode: Constants.API_PROMOCODE});
        this.init();
    }

    /**
     * Init iframe and wait event message
     */
    init() {
        this.$element.html('<iframe id="game" allow="fullscreen; autoplay; encrypted-media" src="https://games.gamindo.com/scacchieri"></iframe>');
        $('#game').on('load', () => {
            window.addEventListener('message', (evt) => {
                this.onMessageReceived(evt);
            }, "*");

            $('#scacchieri').focus();

            // disable scroll page during gaming
            window.addEventListener("keydown", (e) => {
                if(["Space","ArrowUp","ArrowDown","ArrowLeft","ArrowRight"].indexOf(e.code) > -1) {
                    e.preventDefault();
                }
            }, false);
            document.onkeydown = function(evt) {
                evt = evt || window.event;
                var keyCode = evt.keyCode;
                if (keyCode >= 37 && keyCode <= 40) {
                    return false;
                }
            };
        });
    }

    /**
     * Send message to iframe
     * @param obj
     */
    sendMessageToIFrame(obj) {
        $('#game')[0].contentWindow.postMessage(JSON.stringify(obj), '*')
    }

    /**
     * Handling event from iframe
     * @param message
     */
    onMessageReceived(message) {
        if (message.origin == "https://games.gamindo.com"){
            let obj = JSON.parse(message.data);

            if (obj.eventName == "PLAY") {
                GigyaManager.getLoggedUser().then((d) => {
                    if (!d.data["CH_682_MLB_WEB_SCACCHIERI22_NAV_NAV_20220301_20220608"]) {
                        GigyaManager.addCH("CH_682_MLB_WEB_SCACCHIERI22_NAV_NAV_20220301_20220608");
                    }
                })

            } else if (obj.eventName == "LOGIN_REQUEST") {
                window.location.href = "/login?urlBack=" + window.location.pathname + "&regSource=682";
            } else if (obj.eventName == "GAME_READY") {
                // @UTILS - stabilire se usare questo stato o no
            } else if (obj.eventName == "GET_USER_STATS") {
                localStorage.setItem("gamindo_api_stats_json", JSON.stringify({level: obj.level, score: obj.score}));
            } else if (obj.eventName == "USER_LOGGED") {

                GigyaManager.getLoggedUser().then((data) => {
                    const userId = data.UID;

                    this.promoApi.getAuthToken().then((dataToken) => {
                        this.getAvatar(userId).then((dataUser) => {
                            if(dataToken.body){
                                let dataIframe = {
                                    eventName: "USER_LOGGED",
                                    payload: {
                                        name: data.profile.firstName + " " + data.profile.lastName.charAt(0).toUpperCase() + ".",
                                        uid: userId,
                                        access_token: dataToken.body,
                                        profile_image: dataUser.body.path ? dataUser.body.path : "/fe-web/img/icons/avatar_placeholder.jpg"
                                    }
                                };

                                this.sendMessageToIFrame(dataIframe);
                            }
                        });
                    });
                }, () => {
                    let stats = {
                        'eventName': 'USER_LOGGED',
                        'payload': {}
                    };

                    this.sendMessageToIFrame(stats);
                });
            } else if (obj.eventName == "PUT_USER_STATS") {
                let item = localStorage.getItem("gamindo_api_stats_json");
                let stats = {};
                let payload = undefined;
                if (item) {
                    payload = JSON.parse(item);
                }
                stats['eventName'] = "PUT_USER_STATS";
                stats['payload'] = {};

                if(payload !== undefined){
                    stats['payload'] = payload;
                    this.sendMessageToIFrame(stats);
                }else{
                    this.sendMessageToIFrame(stats);
                }
            } else if (obj.eventName == "SAVE_USER_STATS") {
                if(obj.payload){
                    localStorage.setItem("gamindo_api_stats_json", JSON.stringify(obj.payload));
                    let stats = {
                        'eventName': 'SAVE_USER_STATS',
                        'payload': {}
                    };
                    this.sendMessageToIFrame(stats);
                }
            } else if (obj.eventName == "FULLSCREEN") {
                $('#game').addClass("fullscreen");
            } else if (obj.eventName == "MINIMIZE") {
                $('#game').removeClass("fullscreen");
            } else if (obj.eventName == "ANALYTICS") {
            } else if (obj.eventName == "GO_TO_PRIZE_REQUEST") {
                if(obj.payload){
                    window.location.href = '/promozioni/gioca-e-vinci-con-scacchieri/completa-dati?pt=' + obj.payload.play_token + '&iw=1';
                }
            }
        }
    }


    hash(message) {
        return CryptoJS.SHA256(message + "odnimag").toString(CryptoJS.enc.Hex);
    }

    getAvatar(userId) {
        return new Promise((resolve, reject) => {
            HttpClient.doCall({
                method: 'GET',
                url: API_ENDPOINT + '/api/mulinobianco/1.0/web/member/' + userId + '/avatar',
                dataType: "json"
            }, true).then(
                (data) => {
                    resolve(data);
                }, () => reject())
        });
    }
}

export default ScacchieriComponent;